<template>
    <div class="container remove-padding-margin">
        <div class="fixed-judul fixed-top">
            <div class="row justify-content-center align-items-center set-row">
                <div class="col-md-2 col-sm-2 col-2 remove-padding" @click="back">
                    <img src="../../assets/gambar/back-blue.svg" alt="">
                </div>
                <div class="col-md-8 col-sm-8 col-8 text-center remove-padding">
                    <h6 class="remove-margin font-16 font-colorcheck text-promo nomore">Tambah Jenis Gaji</h6>
                </div>
                <div class="col-md-2 col-sm-2 col-2">
                </div>
            </div>
        </div>
        <main class="">
            <div class="flex-100">
                <div class="flex-1 pad-top-66">
                    <div class="add-padding-default color-33333 font-16 line-height-25 letter-space-002 mar-bottom-16" id="jenisgajikosong">Jenis Gaji yang tersedia telah digunakan semuanya.</div>
                    <div class="add-padding-default" id="gajirekom">
                        <div class="mar-bot-12 font-weight-bold">Rekomendasi Kami</div>
                        <div class="card-jenis-gaji custom-control custom-checkbox card-nonactive mar-bot-12 allblue" v-bind:id="gaji.id"
                             v-for="gaji in gajinonaktif" :key="gaji.id" @click="modaladdnominal(gaji)">
                            <label class="letter-space-002 line-height-25 color-0000 remove-margin" v-bind:for="gaji.id">{{gaji.text}}</label>
                            <span class="position-icon"><img src="../../assets/icons/plus.svg" alt=""></span>
                            <div class="font-13 color-6f7 letter-space-002 line-height-20">{{gaji.type}}</div>
                        </div>
                    </div>
                    <div class="border-top-EDED" id="gajiowner">
                        <div class="add-padding-default mar-top-16 font-weight-bold">Dibuat oleh Anda</div>
                            <div class="add-padding-default remove-margin" >
                                <div class="remove-padding flex-1">
                                    <div class="d-flex mar-bot-12"  v-for="gaji_owner in gajiowner" :key="gaji_owner.id">
                                        <div class="bani card-jenis-gaji custom-control custom-checkbox card-nonactive allblue flex-1" v-bind:id="gaji_owner.id" @click="modaladdnominal(gaji_owner)">
                                            <label class="letter-space-002 line-height-25 color-0000 remove-margin" v-bind:for="gaji_owner.id">{{gaji_owner.text}}</label>
                                            <span class="position-icon"><img src="../../assets/icons/plus.svg" alt=""></span>
                                            <div class="font-13 color-6f7 letter-space-002 line-height-20">{{gaji_owner.type}}</div>
                                        </div>
                                        <div class="remove-padding hash" style="padding-left: 12px" @click="modaldel(gaji_owner)">
                                            <span><img class="plus-icon" src="../../assets/icons/Hapsu_owner.svg" alt=""></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="color-206CF add-padding-default p-t-12 p-d-20" data-toggle="modal" data-target="#modaladdjenisgaji"><span><img src="../../assets/icons/plus_3.svg" alt=""></span> Buat baru...</div>
                </div>
            </div>
            <div class="modal fade" id="modaladd" role="dialog">
                <div class="modal-dialog modal-lg  bani-modal">
                    <div class="modal-content">
                        <div class="modal-header">
                            <div class="nav-btn kiri"></div>
                            <h5 class="navbar-title text-center">Tambah Jenis Gaji </h5>
                            <div class="nav-btn kanan tutup">
                                <img src="../../assets/img/x2.svg" data-dismiss="modal" alt="">
                            </div>
                        </div>
                        <div class="modal-body">
                            <div class="row remove-margin">
                                <label class="remove-margin mar-top-12 color-label">{{this.namagaji}}</label>
                                <div class="test col-md-12 col-sm-12 col-12 remove-padding">
                                    <div class="input-group remove-padding">
                                        <div class="input-group-prepend">
                                            <div class="input-group-text">Rp</div>
                                        </div>
                                        <input type="tel" class="form-control inputs" placeholder="14.000" v-model="nominalgaji" v-on:keyup="inputnumberpokok">
                                        <div class="input-group-prepend">
                                            <div class="input-group-text">{{this.typegaji}}</div>
                                        </div>
                                    </div>
	                                <ErrorMessage class="error" label="Nominal" :validation="$v.nominalgaji"></ErrorMessage>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer remove-mar-lr">
                            <div style="margin-right: 0px">
                                <button  type="button" class="btn btn-primary btn-long" @click="aktifjenisgaji" id="btnaktifgaji">Tambahkan
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade" id="modaladdjenisgaji" role="dialog">
                <div class="modal-dialog modal-lg  bani-modal">
                    <div class="modal-content">
                        <div class="modal-header">
                            <div class="nav-btn kiri"></div>
                            <h5 class="navbar-title text-center">Buat Jenis Gaji </h5>
                            <div class="nav-btn kanan tutup">
                                <img src="../../assets/img/x2.svg" data-dismiss="modal" alt="">
                            </div>
                        </div>
                        <div class="modal-body">
                            <div class="row remove-margin">
                                <label class="remove-margin mar-top-12 font-14 color-label">Nama Gaji</label>
                                <input type="text" class="form-control inputs" id="creategaji"
                                       aria-describedby="emailHelp" placeholder="EX:Uang Makan" v-model="namajenisgaji" v-on:keyup="inputnama">
	                            <ErrorMessage class="error" label="Nama Gaji" :validation="$v.namajenisgaji"></ErrorMessage>
                            </div>
	                        <div class="row remove-margin">
	                            <label class="remove-margin mar-top-12 font-14 color-label">Per</label>
                                <select class="form-control" id="selectSatuan" v-model="selectedsatuan" v-on:change="checkvalidatenama">
                                    <option selected value="">
                                        Pilih Satuan
                                    </option>
                                    <option v-for="option in options" v-bind:value="option.value">
                                        {{option.text}}
                                    </option>
                                </select>
	                            <ErrorMessage class="error" label="Satuan" :validation="$v.selectedsatuan"></ErrorMessage>
                            </div>
                        </div>
                        <div class="modal-footer remove-mar-lr">
                            <div style="margin-right: 0px">
                                <button  type="button" class="btn btn-primary btn-long" @click="createjenisgaji" id="btncreatejenis">Simpan
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade" id="modaldeljenisgaji" role="dialog">
                <div class="modal-dialog modal-lg  bani-modal">
                    <div class="modal-content">
                        <div class="modal-header">
                            <div class="nav-btn kiri"></div>
                            <h5 class="navbar-title text-center">Hapus Jenis Gaji </h5>
                            <div class="nav-btn kanan tutup">
                                <img src="../../assets/img/x2.svg" data-dismiss="modal" alt="">
                            </div>
                        </div>
                        <div class="modal-body">
                            <div>Yakin ingin menghapus <b>{{this.namagaji}}</b>?</div>
                        </div>
                        <div class="modal-footer remove-mar-lr">
                            <div style="margin-right: 0px">
                                <button  type="button" class="btn btn-outline-primary btn-long" data-dismiss="modal" @click="deletegajiowner">Ya,Hapus
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade" id="modalcantdel" role="dialog">
                <div class="modal-dialog modal-lg  bani-modal">
                    <div class="modal-content">
                        <div class="modal-header">
                            <div class="nav-btn kiri"></div>
                            <h5 class="navbar-title text-center">Hapus Jenis Gaji </h5>
                            <div class="nav-btn kanan tutup">
                                <img src="../../assets/img/x2.svg" data-dismiss="modal" alt="">
                            </div>
                        </div>
                        <div class="modal-body">
                            <div id="textmodalfalse"><br></div>
                        </div>
                        <br><br>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
	import ErrorMessage from "@/component-items/ErrorMessage";
	import {minLength, required} from "vuelidate/lib/validators";

    export default {
        name: "CategorySallary",
        props:['setidkaryawangaji'],
	    components: { ErrorMessage },
        data(){
            return{
                isClicked:false,
                isClickedloader:false,
                gajinonaktif:[],
                gajiowner:[],
                keynonaktif:0,
                idgajinon:'',
                idkaryawan:this.setidkaryawangaji,
                namakaryawan:'',
                idgaji:'',
                keygaji:0,
                namagaji:'',
                typegaji:0,
                namajenisgaji:'',
                nominalgaji:'',
                selectedsatuan:'',
                options: [
                    { text: 'Periode', value: '1' },
                    { text: 'Perkehadiran', value: '2' },
                    { text: 'Perjam', value: '3' }
                ],
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                }
            }
        },
	    validations: {
		    namajenisgaji: {
		    	required,
			    minLength: minLength(2),
		    },
		    selectedsatuan: {
		    	required,
		    },
		    nominalgaji: {
		    	required
		    },
	    },

        mounted(){
            this.idkaryawan = this.$route.params.idkaryawan
            $('#closeS').hide()
            $('#close').hide()
            $('#jenisgajikosong').hide()
            // this.getgajinonaktif()
            this.checkvalidatenama()
        },
        methods:{
            back(){
                this.$emit('iskategori')
            },

            modaldel(gaji_owner){
                this.keygaji=gaji_owner;
                this.idgaji=gaji_owner.id;
                this.namagaji=gaji_owner.text;
                $('#modaldeljenisgaji').modal('show')
            },

            modalcant(gaji_owner){
                this.namakaryawan = gaji_owner.nama
                $('#modalcantdel').modal('show')
            },

            modaladdnominal(gaji){
                this.keynonaktif = gaji.id
                this.namagaji = gaji.text
                this.typegaji = gaji.type
                $(".allblue").removeClass("card-active")
                $(".allblue").addClass("card-nonactive")
                $('#' + gaji.id).removeClass("card-nonactive");
                $('#' + gaji.id).addClass("card-active");
                $('#modaladd').modal('show')
            },

            inputnama(event){
                var nums = event.target.value;
                var number = nums.replace(/[^0-9A-Za-z.,' -]+/, '');
                this.namajenisgaji = number;
                this.checkvalidatenama()

            },

            checkvalidatenama(){
            	return
                var nama = this.namajenisgaji;
                var selectper = this.selectedsatuan;
                var lenght = nama.length;
                if(lenght>=0 && selectper !== 0){
                    $('#btncreatejenis').prop('disabled', false);
                }else{
                    $('#btncreatejenis').prop('disabled', true);
                }
            },

            inputnumberpokok(event){
                var handleevent = event.target.value;
                var handlenumber = handleevent.replace(/[^0-9]+/);
                this.nominalgaji = handlenumber
                this.formatrupiah(event)
                this.checkvalidatenominal()
            },

            formatrupiah(event){
                var rupiah = event.target.value;
                var formattedrupiah = this.newrupiah(rupiah);
                this.nominalgaji = formattedrupiah
            },

            newrupiah(angka, prefix){
                /* Fungsi formatRupiah */
                var number_string = angka.replace(/[^\d]/g, "").toString(),
                    split = number_string.split(","),
                    sisa = split[0].length % 3,
                    rupiah = split[0].substr(0, sisa),
                    ribuan = split[0].substr(sisa).match(/\d{3}/gi);
                // tambahkan titik jika yang di input sudah menjadi angka ribuan
                if (ribuan) {
                    var separator = sisa ? "." : "";
                    rupiah += separator + ribuan.join(".");
                }

                rupiah = split[1] != undefined ? rupiah + "," + split[1] : rupiah;
                return prefix == undefined ? rupiah : rupiah ? "Rp." + rupiah : "";
            },

            checkvalidatenominal(){
            	return
                var nominal = this.nominalgaji;
                var lenPass = nominal.length;
                if (lenPass >= 2 ) {
                    $('#btnaktifgaji').prop('disabled', false);
                } else {
                    $('#btnaktifgaji').prop('disabled', true);
                }
            },

            async getgajinonaktif(){
                $('#loadingPage').addClass('overlayLoading');
                $('#loadingPage').show()
                this.gajinonaktif = []
                this.gajiowner = [] 
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/list_gaji_nonaktif?idkaryawan=' + this.setidkaryawangaji, this.requestHeaders)
                    if (response.data.status === true) {
                        $('#loadingPage').removeClass('overlayLoading');
                        $('#loadingPage').hide()
                        var rawtahapan = response.data.data
                        for (var i = 0; i < rawtahapan.length; i++) {
                            var type ='-'
                            if(rawtahapan[i].type===1){
                                type = 'Per Periode'
                            }
                            else if(rawtahapan[i].type===2){
                                type = 'Perkehadiran'
                            }
                            else if(rawtahapan[i].type===3){
                                type = 'Perjam'
                            }
                            else{
                                type = '-'
                            }
                            
                            if(rawtahapan[i].owner_idowner === null){
                                this.gajinonaktif.push({
                                    id: rawtahapan[i].id,
                                    text: rawtahapan[i].nama ,
                                    // nominal : rawtahapan[i].pengaturan_gaji.nominal,
                                    // nama : rawtahapan[i].karyawan.nama,
                                    type : type
                                })
                            }else{
                                this.gajiowner.push({
                                    id: rawtahapan[i].id,
                                    text: rawtahapan[i].nama ,
                                    // nominal : rawtahapan[i].pengaturan_gaji.nominal,
                                    // nama : rawtahapan[i].karyawan.nama,
                                    type : type
                                })
                            }
                        }

                        if(this.gajinonaktif.length>0){
                            $('#gajirekom').show()
                        }else{
                            $('#gajirekom').hide()
                        }

                        if(this.gajiowner.length>0){
                            $('#gajiowner').show()
                        }else{
                            $('#gajiowner').hide()
                        }

                        if(this.gajinonaktif.length===0 && this.gajiowner.length===0){
                            $('#jenisgajikosong').show()
                        }else {
                        
                        }
                    }
                }catch (e) {
                	this.$catch_error_response(e)
	                this.isClickedloader = false;
	                this.isClicked=false
	                $('#textbtnsetgaji').show()
	                $('#btnsetgaji').prop('disabled', false);
	                $('#loadingPage').hide()
                }
            },

	        errorValidation() {
		        this.$v.namajenisgaji.$touch()
		        this.$v.selectedsatuan.$touch()
            	return this.$v.namajenisgaji.$invalid || this.$v.selectedsatuan.$invalid
	        },
            async createjenisgaji(){
            	if (this.errorValidation()) {
		            this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
            		return
	            }
                $('#loadingPage').addClass('overlayLoading');
                $('#loadingPage').show()
                try {
                    var idowner = localStorage.getItem('idowner')
                    const createjenis = new FormData()
                    createjenis.append('idowner', idowner)
                    createjenis.append('nama', this.namajenisgaji)
                    createjenis.append('type', this.selectedsatuan)
                    const response = await this.$axios.post(this.$baseurl + '/masterData/gaji/create_jenisgaji?idowner=' + idowner , createjenis, this.requestHeaders)
                    if (response.data.status === true) {
                        this.namajenisgaji='';
                        this.selectedsatuan=0;
                        $('#loadingPage').removeClass('overlayLoading');
                        $('#loadingPage').hide()
                        this.getgajinonaktif()
	                    this.$toast.success(response.data.msg)
	                    $("#modaladdjenisgaji").modal("hide")
                    }else{
                    	this.$toast.error(response.data.msg)
                    }
                }catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').removeClass('overlayLoading');
	                $('#loadingPage').hide()
	                this.isClicked=false
	                $('#textbtnsetgaji').show()
	                $('#btnsetgaji').prop('disabled', false);
	                $('#loadingPage').hide()
                }
            },

            async aktifjenisgaji(){
            	if (this.$v.nominalgaji.$invalid) {
		            this.$v.nominalgaji.$touch()
		            this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
            		return
	            }
                $('#loadingPage').addClass('overlayLoading');
                $('#loadingPage').show()
                try {
                    const aktifjenis = new FormData()
                    aktifjenis.append('nominal', this.nominalgaji)
                    const response = await this.$axios.post(this.$baseurl + '/masterData/gaji/simpan_nominal_gaji?idkaryawan=' + this.setidkaryawangaji + '&idjenisgaji=' + this.keynonaktif , aktifjenis, this.requestHeaders)
                    if (response.data.status === true) {
                        this.nominalgaji = '';
                        this.back()
                        $('#loadingPage').removeClass('overlayLoading');
                        $('#loadingPage').hide()
	                    this.$toast.success(response.data.msg)
	                    $("#modaladd").modal("hide")
                    }else{
                        this.nominalgaji = '';
                        $('#loadingPage').removeClass('overlayLoading');
                        $('#loadingPage').hide()
	                    this.$toast.error(response.data.msg)
                    }
                }catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').removeClass('overlayLoading');
	                $('#loadingPage').hide()
	                this.isClicked=false
	                $('#textbtnsetgaji').show()
	                $('#btnsetgaji').prop('disabled', false);
	                $('#loadingPage').hide()
                 
                }
            },

            async deletegajiowner(){
                $('#loadingPage').addClass('overlayLoading');
                $('#loadingPage').show()
                try {
                    const deletegaji = new FormData()
                    deletegaji.append('idjenisgaji', this.idgaji)
                    const response = await this.$axios.post(this.$baseurl + '/masterData/gaji/hapus_jenis_gaji_owner?'  , deletegaji, this.requestHeaders)
                    if (response.status === 200) {
                        if(response.data.status===true){
                            $('#loadingPage').removeClass('overlayLoading');
                            $('#loadingPage').hide()
                            this.getgajinonaktif()
	                        this.$toast.success(response.data.msg)
                        }else{
                            this.isClickedloader = false;
                            $('#loadingPage').removeClass('overlayLoading');
                            $('#modalcantdel').modal('show')
                            $('#textmodalfalse').html(response.data.msg);
                        }
                    }
                }catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').removeClass('overlayLoading');
	                $('#loadingPage').hide()
	                this.isClicked=false
	                $('#textbtnsetgaji').show()
	                $('#btnsetgaji').prop('disabled', false);
	                $('#loadingPage').hide()
                }
            }
        }
    }
</script>

<style scoped>
    .custom-control-input{
    right: 20px;
    top: 22px;
    }

    .position-icon{
        position: absolute;
        left: 87.5%;
        right: 6.25%;
        top: 31.15%;
        bottom: 36.07%;

    }



</style>